import Image from 'next/legacy/image';
import React from 'react';

import questionMark from 'public/images/question_mark.svg';

const TooltipInfo: React.FC<{ text: string }> = ({ text }) => (
  <div className="relative inline-block group hover:z-[120]">
    <div className="flex px-2 cursor-pointer">
      <Image src={questionMark} alt="help popup" width={20} height={26} />
    </div>
    <div className="hidden group-hover:block fixed inset-x-4 top-1/2 -translate-y-1/2 max-h-[80vh] overflow-y-auto z-[120] p-4 m-0 border md:absolute md:inset-x-auto md:top-auto md:translate-y-0 md:bottom-8 md:-left-20 md:w-52 align-center bg-gold-background border-beige-dark">
      <p className="text-14-26-0.3 font-sohneBuch">{text}</p>
    </div>
  </div>
);

export default TooltipInfo;
